export default __webpack_public_path__ + "static/weekmenu-74e937a819621540dbbe25f944b75d63.jpg";